<template>
  <div class="ql-container ql-snow" style="border: none">
    <div class="ql-editor wysiwyg" v-html="html"></div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  name: "WYSIWYGHtmlElement",
  props: {
    html: {
      required: true
    }
  }
};
</script>

<style scoped></style>
